import styles from './ObjectsContent.module.scss';
import ObjectsContentControl from './ObjectsContentControl/ObjectsContentControl';
import { isMobile } from 'react-device-detect';
import ObjectsAside from '../ObjectsAside/ObjectsAside';

const ObjectsContent = ({ filter, data, getActiveMarker, activeMarker, getFiltereObjects, filteredArray }) => {
  return (
    <div className={styles.content}>
      <ObjectsContentControl filter={filter} getActiveMarker={getActiveMarker} filteredArray={filteredArray} />
      {isMobile && (
        <ObjectsAside data={data} filter={filter} activeMarker={activeMarker} getFiltereObjects={getFiltereObjects} />
      )}
    </div>
  );
};

export default ObjectsContent;
